import { Injectable } from '@angular/core';
import { TotalPriceComponent } from '../../components/total-price/total-price.component';
import { AvailableStepsInNavigationBar, NavigationBarItem, RouteIds, Step } from '../../types';
import { BaseStepDefinitionStrategy } from './base-step-definition.strategy';
import { StepDefinitionStrategy } from './step-definition.strategy';
import { getQuoteStepsNavigationBarItems } from '../../utils';
import { GoogleAnalyticsEventEnum } from '../../google-analytics';
import { Flow } from '@lx/quote-tool/lite/shared/types';

@Injectable({
  providedIn: 'root',
})
export class QuoteStepDefinitionService extends BaseStepDefinitionStrategy implements StepDefinitionStrategy {
  private stepDefinition: Step = {
    id: RouteIds.quote,
    title: $localize`Your quote`,
    subtitles: [$localize`Within 48 hours, one of our agents will contact you to complete the customization of your experience.`],
    floatingPanel: {
      component: TotalPriceComponent,
      position: 'title',
      enabledMobile: true,
      mobilePosition: 'bottom',
    },
    googleAnalyticsEvent: GoogleAnalyticsEventEnum.Quote,
    nextStep: () => RouteIds.booking,
  };

  getStepDefinition(activeFlow: Flow) {
    return {
      ...this.stepDefinition,
      navigationBarItems: this.getNavigationBarItems(activeFlow),
    };
  }

  fillNavigationBarItemsProperties(
    baseNavigationBarItems: Record<AvailableStepsInNavigationBar, NavigationBarItem>,
    activeFlow: Flow,
  ): Record<AvailableStepsInNavigationBar, NavigationBarItem> {
    return getQuoteStepsNavigationBarItems(activeFlow, baseNavigationBarItems);
  }
}
